import { authHeader } from './auth-header'
import store from '@/state/store'

export const userService = {
  login,
  loginSocial,
  logout,
  register,
  getAll,
  getCurrentUser,
  resetPassword,
  changePassword,
  getApplication,
}

function getCurrentUser() {
  const requestOptions = {
    method: 'GET',
  }
  return fetch(`/users/me`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      // login successful if there's a jwt token in the response
      if (user) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user_object', JSON.stringify(user))
      }
      return user
    })
    .catch((error) => {
      console.log(error)
      // store.dispatch('authfack/logout')
    })
}

function login(email, password, client_id, client_secret, totpc) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, client_id, client_secret, totpc }),
  }
  return fetch(`/auth/token/`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      // login successful if there's a jwt token in the response
      if (user.token) {
        localStorage.setItem('user', JSON.stringify(user))
        localStorage.setItem('user_token', user.token)
        getCurrentUser()
      }
      return user
    })
}

function loginSocial(token, client_id, client_secret, provider) {
  let socialMapping = {
    google: 'google-oauth2',
    microsoft: 'microsoft-graph',
    apple: 'apple-id',
  }
  let backend = socialMapping[provider]
  console.log(token)
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, client_id, client_secret, backend }),
  }
  return fetch(`social/auth/convert-token/`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      // login successful if there's a jwt token in the response
      if (user.token) {
        localStorage.setItem('user', JSON.stringify(user))
        localStorage.setItem('user_token', user.token)
        getCurrentUser()
      }
      return user
    })
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user')
  localStorage.removeItem('user_object')
  localStorage.removeItem('user_token')
}

function register(user) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(user),
  }
  return fetch(`/users/`, requestOptions).then(handleResponse)
}

function resetPassword(email) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  }
  return fetch(`/auth/password_reset/`, requestOptions).then(handleResponse)
}

function changePassword(token, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, password }),
  }
  return fetch(`/auth/password_reset/confirm/`, requestOptions).then(handleResponse)
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  }
  return fetch(`/users/`, requestOptions).then(handleResponse)
}

function getApplication(email) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    body: JSON.stringify({ email }),
  }
  return fetch(`/get_applications/`, requestOptions)
    .then(handleResponse)
    .then((applications) => {
      return applications
    })
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout()
        location.reload(true)
      }
      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
